import { render, staticRenderFns } from "./AjusteVerba.vue?vue&type=template&id=31394433&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/orcamento/ajuste-verba/AjusteVerba.vue
// module id = 998
// module chunks = 28